(() => {
  const slider = document.querySelector('.q-js-mainImageBanner_slider');
  if(!slider) {
    return
  }

  function getHeightOptionPc(option) {
    switch (option) {
      case "small":
        return 0.5;
      case "medium":
        return 0.5625;
      case "large":
        return 0.75;
      default:
        break;
    }
  }
  function getHeightOptionSp(option) {
    switch (option) {
      case "small":
        return 0.5625;
      case "medium":
        return 0.5625;
      case "large":
        return 1;
      default:
        break;
    }
  }

  const options = {
    type: slider.dataset.type,
    rewind: slider.dataset.type === "fade" ? true : false,
    autoplay: JSON.parse(slider.dataset.autoplay),
    height_pc: getHeightOptionPc(slider.dataset.height),
    height_sp: getHeightOptionSp(slider.dataset.height),
    interval: slider.dataset.interval * 1000,
    speed: slider.dataset.speed * 1000,
  }

  new Splide( slider, {
    type: options.type,
    rewind: options.rewind,
    autoplay: options.autoplay,
    heightRatio: options.height_pc,
    interval: options.interval,
    speed: options.speed,
    pagination: true,
    arrows: false,
    pauseOnHover: false,
    reducedMotion: {
      autoplay: true, // 視差効果を減らすがONでも自動再生を続ける
      interval: options.interval,
      speed: options.speed,
    },
    classes: {
      pagination: 'splide__pagination q-pagination_position',
    },
    breakpoints: {
      750: {
        heightRatio: options.height_sp,
      },
    }
  }).mount();
})();
